/** @enum {string} */
export const TransactionTypes = {
    /** Use for package item */
    Manual: 'manual',
    /** Use for device item */
    Recurring: 'recurring',
    /** Use for any other item */
    CardActivation: 'card activation'
};


// WEBPACK FOOTER //
// ./src/app/shared/ecommerce/enums/transactionTypes.ts